// import React from "react";
// import Form from "../../../site/forms/independent/form";
// import {
//   calculationRules,
//   formFields,
//   formHeading,
//   submitApi,
//   validationRules,
// } from "./module";
// import { useState } from "react";
// import { useEffect } from "react";
// import { useParams } from "react-router-dom";

// function WorkTypeForm() {
//   const [data, setData] = useState(null);
//   const { rowId } = useParams();

//   useEffect(() => {
//     const fetchData = async () => {
//       const token = localStorage.getItem("zTaskAuthToken");
//       try {
//         if (!rowId) return;
//         const response = await fetch(`${submitApi}/${rowId}`, {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         });

//         if (response.ok) {
//           const result = await response.json();
//           setData(result);
//         } else {
//           console.error("API Error:", response.statusText);
//         }
//       } catch (error) {
//         console.error("Network or unexpected error:", error);
//       }
//     };

//     fetchData();
//   }, [rowId]);
//   return (
//     <Form
//       formFields={formFields}
//       submitApi={submitApi}
//       formHeading={formHeading}
//       validationRules={validationRules}
//       calculationRules={calculationRules}
//       data={data}
//     />
//   );
// }

// export default WorkTypeForm;



import React from "react";
import Form from "../../../site/forms/independent/form";
import {
  calculationRules,
  formFields,
  formHeading,
  submitApi,
  validationRules,
} from "./module";
import { useState } from "react";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

// --- FIX: Changed component to accept a prop for the ID ---
function WorkTypeForm({ workTypeId }) {
  const [data, setData] = useState(null);
  
  // The ID for fetching data now comes from the prop
  const rowId = workTypeId;

  useEffect(() => {
    const fetchData = async () => {
      // If there's no rowId, it's a new form, so clear existing data
      if (!rowId) {
        setData(null);
        return;
      }
      
      const token = localStorage.getItem("zTaskAuthToken");
      try {
        const response = await fetch(`${submitApi}/${rowId}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.ok) {
          const result = await response.json();
          setData(result);
        } else {
          console.error("API Error:", response.statusText);
        }
      } catch (error) {
        console.error("Network or unexpected error:", error);
      }
    };

    fetchData();
  }, [rowId]); // Re-run the effect if the ID changes

  return (
    <Form
      formFields={formFields}
      submitApi={submitApi}
      formHeading={formHeading}
      validationRules={validationRules}
      calculationRules={calculationRules}
      data={data}
    />
  );
}

export default WorkTypeForm;